import { inject, InjectionToken } from "@angular/core";
import { SideNavService } from "@app/shared-core/components/side-nav/services/side-nav.service";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";

export const ASSETS_SIDENAV_LINKS = new InjectionToken<void>("ASSETS_SIDENAV_LINKS", {
  providedIn: "root",
  factory: () => {
    const sideNavService = inject(SideNavService);
    sideNavService.addSubMenuItems("assets", [
      {
        id: "CarAssets",
        label: "ASSETS.ITEMS.CAR_ASSETS",
        icon: "car",
        expanded: true,
        items: [
          {
            id: "CarAssetsTypes",
            label: "ASSETS.ITEMS.CAR_ASSET_TYPES",
            routerLink: "/assets/car-asset-types",
            permissions: COMMON_GUARD_OPTIONS.CAR_ASSET_TYPE.VIEW.permissions,
          },
          {
            id: "CarAssets",
            label: "ASSETS.ITEMS.CAR_ASSETS",
            routerLink: "/assets/car-assets",
            permissions: COMMON_GUARD_OPTIONS.CAR_ASSET.VIEW.permissions,
          },
        ],
      },
      {
        id: "FuelCards",
        icon: "card",
        label: "ASSETS.ITEMS.FUEL_CARDS",
        routerLink: "/assets/fuel-cards",
        permissions: COMMON_GUARD_OPTIONS.FUEL_CARD.VIEW.permissions,
      },
      {
        id: "PosDevices",
        icon: "pos",
        label: "ASSETS.ITEMS.POS_DEVICES",
        routerLink: "/assets/pos-devices",
        permissions: COMMON_GUARD_OPTIONS.POS_DEVICE.VIEW.permissions,
      },
      {
        id: "DocumentScanners",
        icon: "scan",
        label: "ASSETS.ITEMS.DOCUMENT_SCANNERS",
        routerLink: "/assets/document-scanners",
        permissions: COMMON_GUARD_OPTIONS.DOCUMENT_SCANNER.VIEW.permissions,
      },
      {
        id: "OtherAssets",
        icon: "tablet",
        label: "ASSETS.ITEMS.OTHER_ASSETS",
        items: [
          {
            id: "DeviceTags",
            label: "ASSETS.ITEMS.DEVICE_TAGS",
            routerLink: "/assets/device-tags",
            permissions: COMMON_GUARD_OPTIONS.DEVICE_TAG.VIEW.permissions,
          },
          {
            id: "Devices",
            label: "ASSETS.ITEMS.DEVICES",
            routerLink: "/assets/devices",
            permissions: COMMON_GUARD_OPTIONS.DEVICE.VIEW.permissions,
          },
          {
            id: "SimCards",
            label: "ASSETS.ITEMS.SIM_CARDS",
            routerLink: "/assets/sim-cards",
            permissions: COMMON_GUARD_OPTIONS.SIM_CARD.VIEW.permissions,
          },
          {
            id: "SignatureLicenses",
            label: "ASSETS.ITEMS.SIGNATURE_LICENSES",
            routerLink: "/assets/signature-licenses",
            permissions: COMMON_GUARD_OPTIONS.SIGNATURE_LICENSE.VIEW.permissions,
          },
          {
            id: "ConsumableMaterials",
            label: "ASSETS.ITEMS.CONSUMABLE_MATERIALS",
            routerLink: "/assets/consumable-materials",
            permissions: COMMON_GUARD_OPTIONS.CONSUMABLE_MATERIAL.VIEW.permissions,
          },
        ],
      },
    ]);
  },
});
